import React from 'react';
import GmpPage from './GmpPage';

// /sme-ipo-gmp: the GMP board limited to SME issues, with SME-specific text
export const SmeGmpPage = () => <GmpPage variant="sme" />;

export default SmeGmpPage;
